import { render, staticRenderFns } from "./KnFormFieldRow.vue?vue&type=template&id=225b2b64"
import script from "./KnFormFieldRow.vue?vue&type=script&lang=js"
export * from "./KnFormFieldRow.vue?vue&type=script&lang=js"
import style0 from "./KnFormFieldRow.vue?vue&type=style&index=0&id=225b2b64&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports